/**
 * Platform-aware shadow helper.
 * React Native Web deprecated shadow* props in favor of CSS boxShadow.
 * Native still uses shadow* + elevation.
 */
import { Platform, type ViewStyle } from 'react-native'

interface ShadowParams {
  x?: number
  y?: number
  blur?: number
  spread?: number
  color?: string
  opacity?: number
  elevation?: number
}

export function webShadow({
  x = 0,
  y = 2,
  blur = 8,
  spread = 0,
  color = '#000',
  opacity = 0.08,
  elevation = 3,
}: ShadowParams = {}): ViewStyle {
  if (Platform.OS === 'web') {
    // Parse hex color and apply opacity
    const r = parseInt(color.slice(1, 3), 16) || 0
    const g = parseInt(color.slice(3, 5), 16) || 0
    const b = parseInt(color.slice(5, 7), 16) || 0
    return {
      boxShadow: `${x}px ${y}px ${blur}px ${spread}px rgba(${r},${g},${b},${opacity})`,
    } as ViewStyle
  }
  return {
    shadowColor: color,
    shadowOffset: { width: x, height: y },
    shadowOpacity: opacity,
    shadowRadius: blur,
    elevation,
  }
}

/** Preset shadows matching SHADOWS token scale but web-compatible */
export const WEB_SHADOWS = {
  sm: webShadow({ y: 1, blur: 4, opacity: 0.06, elevation: 2 }),
  md: webShadow({ y: 3, blur: 12, opacity: 0.08, elevation: 4 }),
  lg: webShadow({ y: 6, blur: 20, opacity: 0.1, elevation: 8 }),
  xl: webShadow({ y: 10, blur: 32, opacity: 0.14, elevation: 12 }),
} as const
